import React from 'react';
import { Typography, Card, Button, Space } from 'antd';
import { FormOutlined, LinkOutlined } from '@ant-design/icons';

const { Title, Paragraph, Text } = Typography;

export default function ScenarioSiteLOI({ slug, siteInfo }) {
  const brandColor = siteInfo?.brand_color || '#1890ff';
  const template = siteInfo?.site_template || 'modern';
  const isMinimal = template === 'minimal';
  const isClassic = template === 'classic';

  const cardRadius = isMinimal ? 0 : isClassic ? 4 : 12;
  const btnRadius = isMinimal ? 0 : isClassic ? 4 : undefined;
  const cardShadow = isMinimal ? 'none' : isClassic ? '0 1px 4px rgba(0,0,0,0.08)' : '0 2px 8px rgba(0,0,0,0.1)';

  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: '40px 24px' }}>
      <Title level={2} style={{
        textAlign: isMinimal ? 'left' : 'center',
        marginBottom: 8,
        fontWeight: isMinimal ? 300 : 600,
        letterSpacing: isMinimal ? 1 : 0,
        borderBottom: isMinimal ? `2px solid ${brandColor}` : 'none',
        paddingBottom: isMinimal ? 8 : 0,
        display: isMinimal ? 'inline-block' : 'block',
      }}>
        <FormOutlined style={{ marginRight: 8 }} />
        意向書填寫
      </Title>
      <Paragraph type="secondary" style={{
        textAlign: isMinimal ? 'left' : 'center',
        marginBottom: 40,
      }}>
        請填寫意向書，表達您對產品的購買意願
      </Paragraph>

      <Card style={{
        textAlign: 'center',
        padding: '40px 24px',
        borderRadius: cardRadius,
        border: isMinimal ? '1px solid #e8e8e8' : undefined,
        boxShadow: cardShadow,
      }}>
        <Space direction="vertical" size={24} align="center">
          <div style={{
            width: 80, height: 80,
            borderRadius: isMinimal ? 0 : '50%',
            background: `${brandColor}15`,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <FormOutlined style={{ fontSize: 36, color: brandColor }} />
          </div>

          <div>
            <Title level={4} style={{ marginBottom: 8 }}>數發局軟體採購意向書</Title>
            <Paragraph type="secondary">
              點擊下方按鈕前往意向書調查頁面，<br />
              選擇您感興趣的品牌與產品，填寫預估採購數量。
            </Paragraph>
          </div>

          <Button
            type="primary"
            size="large"
            icon={<LinkOutlined />}
            href="/survey/latest"
            target="_blank"
            style={{
              background: brandColor,
              borderColor: brandColor,
              borderRadius: btnRadius,
            }}
          >
            前往填寫意向書
          </Button>

          <Text type="secondary" style={{ fontSize: 12 }}>
            意向書資料僅供內部評估使用，不代表正式訂單承諾
          </Text>
        </Space>
      </Card>
    </div>
  );
}
